<template>
  <div class="yazdirtable">
    <table class="table table-bordered">
      <thead>
      <tr>
        <th width="40">No</th>
        <th width="80">Talep Tarihi</th>
        <th width="100">Randevu Zamanı</th>
        <th width="120">Ad Soyad</th>
        <th width="80">Telefon</th>
        <th>Adres</th>
        <th>Bölge</th>
        <th>Açıklama</th>
        <th width="100">Personel</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="l in data">
        <td>{{ l.id }}</td>
        <td>{{ l.tarih }}</td>
        <td>{{ l.Randevu }}</td>
        <td>{{ l.AdSoyad }}</td>
        <td>{{ l.Telefon }}</td>
        <td>{{ l.Adres }}</td>
        <td>{{ l.Bolge }}</td>
        <td>{{ l.Aciklama }}</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/JetUsta/Comp/juTalepYazdir.vue